import { Component } from "react";

import getAuthenticationWorker from "./AuthenticationWorker";

class SigninSilent extends Component {
  constructor(props) {
    super(props);

    console.log("SiginSilent");

    getAuthenticationWorker().onSigninSlientCallback();
  }

  render() {
    return null;
  }
}

export default SigninSilent;
